<div class="app-ActionBar-content">
  <ng-content select="appActionBarLeftContentDirective"></ng-content>
  <ng-content select="appActionBarCenterContent"></ng-content>
  <ng-content select="appActionBarRightContent"></ng-content>
</div>
